import {
    Component,
    DoCheck,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DirectoryService } from "../../services/directory.service";
import { IPasswordRule } from "../../models/domain";


@Component({
    selector: 'app-enter-new-password',
    templateUrl: './enterNewPassword.component.html',
    styleUrls: ['./enterNewPassword.component.scss'],
})
export class EnterNewPasswordComponent implements OnInit, OnDestroy, DoCheck {
    private _repeatPasswordErrorTranslate: string;
    public defaultPasswordRule = "Пароль должен соответствовать требованиям сложности";

    constructor(
        private _translateService: TranslateService,
        private _directoryService: DirectoryService,
    ) {
    }

    public errorText: string;
    public regexPasswordRuleList: IPasswordRule[] = [];
    public otherPasswordRuleList: IPasswordRule[] = [];

    private _passwordValue: string;
    public get passwordValue(): string {
        return this._passwordValue;
    }
    public set passwordValue(value: string) {
        this._passwordValue = value;
        this.errorText = null;
        this._evaluateRegexPasswordRules();
        this.clearErrors(this.otherPasswordRuleList);
    }

    public _repeatPasswordValue: string;
    public get repeatPasswordValue(): string {
        return this._repeatPasswordValue;
    }
    public set repeatPasswordValue(value: string) {
        this._repeatPasswordValue = value;
        this.errorText = null;
    }


    @Input() submitButtonText: string;
    @Output() submited = new EventEmitter();

    ngOnInit(): void {
        this._initTranslations();

        this._directoryService.getAllPasswordRules()
            .subscribe(response => {
                response.forEach(q => q.isError = null);
                this.regexPasswordRuleList = response.filter(q => q.regexRule != null);
                this.otherPasswordRuleList = response.filter(q => q.regexRule == null);
            });
    }

    ngDoCheck(): void {
    }

    ngOnDestroy(): void {
    }

    private _initTranslations() {
        this._translateService.get(
            [
                'Components.EnterNewPassword.RepeatPasswordError'
            ])
            .subscribe(
                result => {
                    this._repeatPasswordErrorTranslate = result['Components.EnterNewPassword.RepeatPasswordError'];
                });
    }

    private _evaluateRegexPasswordRules() {
        if (this.regexPasswordRuleList.length === 0) {
            return;
        }

        if (!this._passwordValue) {
            this.regexPasswordRuleList.forEach(rule => {
                rule.isError = null;
            });
            return;
        }

        this.regexPasswordRuleList.forEach(rule => {
            var regex = new RegExp(rule.regexRule);
            rule.isError = !regex.test(this._passwordValue);
        });
    }

    public evaluatePasswordRules(arr: IPasswordRule[]) {
        if (!arr)
            return;

        arr.forEach(inputRule => {
            var localRule =
                this.regexPasswordRuleList.filter(q => q.text === inputRule.text)[0] ??
                this.otherPasswordRuleList.filter(q => q.text === inputRule.text)[0];

            if (localRule) {
                localRule.isError = inputRule.isError;
            }
        });
    }

    public submitButtonClick(event: Event): void {

        this.errorText = null;

        if (this.passwordValue !== this.repeatPasswordValue) {
            this.errorText = this._repeatPasswordErrorTranslate;
            return;
        }

        this._evaluateRegexPasswordRules();
        if (this.regexPasswordRuleList.some(q => q.isError)) {
            return;
        }

        this.submited.emit();
    }

    public clear() {
        this.errorText = null;
        this.passwordValue = null;
        this.repeatPasswordValue = null;
    }

    public clearErrors(arr: IPasswordRule[]) {
        arr.forEach(rule => {
            rule.isError = null;
        });
    }
}
